<template>
  <div class="emd-tip _hoverble eu-mx_1">
    <div class="emd-tip__container">
      <div
        class="emd-tip__box _color_contrast _arrow_top _position_bottom _no_shadow eu-mt_2 eu-ml_2"
      >
        {{ $t('copy') }}
      </div>
    </div>
    <emd-button
      color="primary"
      type="text"
      @click="$emit('click')"
      class="eu-flex eu-align-items_center"
    >
      <emerald-icon
        icon="copy"
        data-testid="button-copy"
      />
    </emd-button>
  </div>
</template>

<script>
import { EmdButton, EmeraldIcon } from 'emerald-vue/src/components'

export default {
  components: {
    EmeraldIcon,
    EmdButton
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "copy": "Replicar",
    "copyToAll": "Replicar para todos"
  },
  "en-US": {
    "copy": "Replicate",
    "copyToAll": "Replicate to all"
  }
}
</i18n>
